<template>
  <div class="footer">
    <!-- <promo_carousel></promo_carousel> -->
    <footer_forms @refresh="componentKey+=1" :key="componentKey"></footer_forms>
  </div>
</template>

<script>
//import promo_carousel from "../promo_carousel";
import footer_forms from "../footer_forms";

export default {
  data: function(){
    return{
      componentKey: 0,
    };
  },
  components: {
  //  promo_carousel,
    footer_forms,
  },
};
$(window).on('unload', function() {
  $(window).scrollTop(0);
});
</script>

<style lang="scss" scoped>
.footer{
  padding: 0;
  background-color: inherit;
  //margin-top: 200px;

}
</style>
